import { toColor } from '@printu/geom';
import { getTextFormat } from 'app/core/markers/models';
export const getTextFillPainter = (marker) => (pCtx) => {
    let offsetY = 0;
    const { lines } = marker;
    lines.forEach(line => {
        pCtx.fillText(line.text, 0, offsetY);
        offsetY += line.height;
    });
};
export const getTextStrokePainter = (marker) => (pCtx) => {
    let offsetY = 0;
    const { lines } = marker;
    lines.forEach(line => {
        pCtx.strokeText(line.text, 0, offsetY);
        offsetY += line.height;
    });
};
export const renderText = (marker, fonts, ctx, renderer) => {
    ctx.save();
    ctx.translate(marker.x, marker.y);
    const format = getTextFormat(marker);
    let fontSize;
    switch (format.metrics) {
        case 'pt':
            fontSize = `${format.fontSize}pt`;
            break;
        case 'rem':
            // 1em = 12pt
            fontSize = `${format.fontSize * fonts.remBase}px`;
            break;
        case 'em':
            // 1em = 12pt
            fontSize = `${format.fontSize * fonts.emBase}px`;
            break;
        default:
            fontSize = '16pt';
            break;
    }
    ctx.font = `${fontSize} ${format.fontFamily}`;
    ctx.textAlign = 'left';
    const minAllowedStroke = 8;
    const strokeWidth = format.fontSize * 0.5;
    const style = {
        fillColor: marker.color,
        strokeColor: '#FFFFFF',
        strokeWidth: Math.round(Math.max(strokeWidth, minAllowedStroke)),
        shadowColor: toColor(0x000000, 0.2),
        shadowBlur: 2,
        shadowOffset: { x: 0, y: 4 },
    };
    renderer(style);
    ctx.restore();
};
